<template>
    <div :class="divClass">
        <inertia-link :href="href" class="flex items-center"
        >
            <slot />
        </inertia-link>
    </div>
</template>

<script>
    export default {
        props: ['href', 'active'],

        computed: {
            divClass() {
                let main = 'w-full text-white my-6 px-4 ';
                return this.active
                        ? main
                        : main
            }
        },
        components : {
        }
    }
</script>
